<template>
  <div id="app">
    <template v-if="administrator">
      <Navbar></Navbar>
    </template>
    <router-view />
  </div>
</template>
<script>
import Navbar from '@/components/Navbar'
import Vue from 'vue'
import { hapiickApi, setToken } from '@/api/hapiickApi';

export default {
  name: 'App',
  data() {
    return {
      administrator: false
    }
  },
  created() {
    if (localStorage.theme) {
      document.documentElement.style.setProperty('--var-color', JSON.parse(localStorage.theme).primary_color)
    } else {
      document.documentElement.style.setProperty('--var-color', this.$primary_color_default)
    }
    this.putNavbar()
    this.checkLogin()
  },
  updated() {
    this.putNavbar()
    this.checkLogin()
  },
  methods: {
    checkLogin() {
      if (!localStorage.token || !localStorage.admin || !localStorage.company) {
        this.$router.replace('/')
        localStorage.clear()
        setToken(null)
      } else {
        hapiickApi().post('/v1/login/check', {
          admin_id: JSON.parse(localStorage.admin).id,
          role: JSON.parse(localStorage.admin).role
        })
          .then(request => this.checkSessionOpen(request))
          .catch(() => {
            localStorage.clear()
            setToken(null)
          })
      }
    },
    checkSessionOpen(req) {
      if (req.data.status === 'open') {
        // document.documentElement.style.setProperty('--var-color', localStorage.color)
        console.log('sessionOK')
      } else {
        this.$router.replace('/')
        localStorage.clear()
        setToken(null)
      }
    },
    putNavbar() {
      if (localStorage.admin && localStorage.token && localStorage.company && !JSON.parse(localStorage.admin).change_pass) {
        this.administrator = true
      } else {
        this.administrator = false
      }
    }
  },
  components: {
    Navbar
  }
}
</script>

<style>
:root {
  --var-color: JSON.parse(LocalStorage.theme).primary_color;
  /* --var-color: this.$store.statee.primary_color; */
}

#app {
  width: 100%;
}

a {
  cursor: pointer;
}

.panelNagusia {
  margin-top: 6rem !important;
  margin-left: 18rem !important;
  margin-right: 4rem !important;
}

.ui.breadcrumb a {
  color: black !important;
}

.rightButton {
  float: right;
  margin-top: -4rem !important;
  margin-right: 1rem !important;
}

.ui.container {
  min-width: 100%;
}

.eskubian {
  float: right;
}

.hapiick {
  color: var(--var-color) !important;
  /* color: #00f9a9 !important; */
}

.loader {
  margin-top: 10rem !important;
}

.ui.loader:after,
.ui.loader:before {
  width: 6rem;
  height: 6rem;
}

.table {
  width: 100% !important;
}

/*element.style {}*/

*,
:after,
:before {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
}

.vgt-table th.sorting {
  cursor: pointer;
}

.vgt-table thead th {
  color: #606266;
  vertical-align: bottom;
  border-bottom: 1px solid #DCDFE6;
  padding-right: 1.5em;
  background: -webkit-gradient(linear, left top, left bottom, from(#F4F5F8), to(#F1F3F6));
  background: linear-gradient(#F4F5F8, #F1F3F6);
}

.vgt-left-align {
  text-align: left;
}

table.vgt-table {
  font-size: 11px !important;
}

.vgt-table th {
  padding: .3em 1.2em .3em .3em !important;
}

.vgt-input,
.vgt-select {
  font-size: 10px !important;
}

.vgt-wrap__footer {
  padding: .4em !important;
}

table.vgt-table tr.clickable:hover {
  background-color: var(--var-color) !important;
}

.vgt-input:focus,
.vgt-select:focus {
  border-color: var(--var-color) !important;
}

/* Para customizar el color de un boton */
/* .ui.custom-color.button {
  background-color: var(--var-color);
  color: #fff;
} */

.field input:focus,
input:focus,
textarea:focus,
.ui.selection.dropdown:focus {
  border-color: var(--var-color) !important;
}

.ui.toggle.checkbox input:checked~.box:before,
.ui.toggle.checkbox input:checked~label:before {
  background-color: var(--var-color) !important;
}

.azpian {
  vertical-align: bottom !important;
}

.error {
  color: red;
}

.swal2-icon.swal2-question,
.swal2-icon.swal2-info {
  border-color: #bcbdbd !important;
  color: #767676 !important;
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-confirm:focus {
  background-color: #00f9a9 !important;
  border: solid #00f9a9 !important;
  color: black !important;
  width: 210px !important;
  box-shadow: unset !important;
}

.swal2-styled.swal2-cancel,
.swal2-styled.swal2-deny {
  background-color: black !important;
  border: solid black !important;
  color: white !important;
  width: 210px !important;
}

.ui.search.dropdown>input.search {
  width: 100% !important;
}

@media only screen and (max-width: 600px) {
  .panelNagusia {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .rightButton {
    margin-right: 0rem !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue